import accountImgDefault from "@/assets/svgs/account-img-default.svg";
import { useState } from "react";

export function GetImageSource(url) {
    if (!!url) {
        return url;
    }

    return accountImgDefault;
}

export function OnImageError(event) {
    const { target } = event;
    if (!target) {
        return;
    }
    target.onerror = null;
    target.src = accountImgDefault;
}

const PackageParticipantsLists = ({ title, packageInfo }) => {

    const [participantsList] = useState(packageInfo?.participants);

    return (
        <>
            <div className="package-participants__container">
                <div className="package-participants__title">{title}</div>

                <div className="package-participants__lists-name">
                    {participantsList?.length === 0 && <div>No participant</div>}
                    {participantsList?.map((participant) =>
                        <div key={participant.id} className="package-participants__content">
                            <span className="package-participants__icon">
                                <img data-testid="account-img"
                                    src={GetImageSource(
                                        participant.iconUrl
                                    )}
                                    onError={OnImageError}
                                />
                            </span>
                            <span className="package-participants__name">{participant.name}</span>
                        </div>
                    )}
                </div>
            </div>
        </>
    )

};

export default PackageParticipantsLists;
